import React from 'react';

const Footer = () => {
  return (
    // 💡 ID yahan add kar di gayi hai
    <footer id="footer" className="mt-5" style={{ backgroundColor: '#0f172a', color: '#f8fafc', fontFamily: 'Poppins, sans-serif' }}>
      
      <div className="container py-5">
        <div className="row g-4">
          
          <div className="col-lg-4 col-md-6 pe-lg-5">
            <h4 className="fw-bold mb-3 d-flex align-items-center">
              <span style={{ color: '#f8fafc' }}>JAIRAJI </span>
              <span style={{ color: '#38bdf8', marginLeft: '6px' }}>TRUST</span>
            </h4>
            <p className="text-white-50 mb-4" style={{ fontSize: '0.95rem', lineHeight: '1.7' }}>
              Committed to bridging the opportunity gap in rural areas by providing high-quality education and industry-relevant skill training to make individuals self-reliant.
            </p>
            <div className="d-inline-block border border-secondary rounded px-3 py-2 text-white-50 small">
              <strong>DARPAN ID:</strong> UP/2025/0931093
            </div>
          </div>

          <div className="col-lg-4 col-md-6">
            <h5 className="fw-bold mb-4 pb-2" style={{ color: '#f8fafc' }}>Quick Links</h5>
            <ul className="list-unstyled mb-0 d-flex flex-column gap-3">
              <li><a href="#home" className="text-white-50 text-decoration-none footer-link">Home</a></li>
              <li><a href="#about" className="text-white-50 text-decoration-none footer-link">About Us</a></li>
              <li><a href="#sectors" className="text-white-50 text-decoration-none footer-link">Our Initiatives</a></li>
              <li><a href="#gallery" className="text-white-50 text-decoration-none footer-link">Training Centers</a></li>
            </ul>
          </div>

          <div className="col-lg-4 col-md-12">
            <h5 className="fw-bold mb-4 pb-2" style={{ color: '#f8fafc' }}>Get in Touch</h5>
            <ul className="list-unstyled mb-0 d-flex flex-column gap-3 text-white-50" style={{ fontSize: '0.95rem' }}>
              <li className="d-flex align-items-start gap-3">
                <span className="fs-5" style={{ color: '#38bdf8' }}>📍</span>
                <span>64 Pura Nand Lal, Machhalishahar,<br/>Jaunpur, Uttar Pradesh - 222143</span>
              </li>
              <li className="d-flex align-items-center gap-3">
                <span className="fs-5" style={{ color: '#38bdf8' }}>✉️</span>
                <a href="mailto:vkpaldoc777@gmail.com" className="text-white-50 text-decoration-none footer-link">
                  vkpaldoc777@gmail.com
                </a>
              </li>
              <li className="d-flex align-items-center gap-3">
                <span className="fs-5" style={{ color: '#38bdf8' }}>📞</span>
                <span>+91 7007205910</span>
              </li>
            </ul>
          </div>

        </div>
      </div>

      <div style={{ borderTop: '1px solid rgba(255,255,255,0.1)' }}>
        <div className="container py-4 text-center">
          <p className="mb-0 text-white-50 small" style={{ letterSpacing: '0.5px' }}>
            &copy; {new Date().getFullYear()} Jairaji Educational Trust. All rights reserved.
          </p>
        </div>
      </div>

      <style>{`
        .footer-link { transition: color 0.3s ease; }
        .footer-link:hover { color: #38bdf8 !important; text-decoration: underline !important; }
      `}</style>
      
    </footer>
  );
};

export default Footer;